// Copyright 1999-2020. Plesk International GmbH. All rights reserved.

import { render, createElement, LocaleProvider } from '@plesk/ui-library';
import CookiePolicy, { togglePreferences } from './CookiePolicy';

module.exports = {
    default: ({ container, locale, ...props }) => {
        render(
            <LocaleProvider messages={locale}>
                <CookiePolicy {...props} />
            </LocaleProvider>,
            container
        );
    },
    togglePreferences,
};



// WEBPACK FOOTER //
// ./app/cookie-policy/index.js